import config from '../config';


type LoggerConfig = {
  enabled: boolean;
  prefix?: string;
};

// make it true if needs console.logs
const defaultConfig: LoggerConfig = {
  enabled:config.LOG.ENABLED,
  prefix: config.LOG.PREFIX,
};

class Logger {
  private config: LoggerConfig = defaultConfig;

  configure(partial: Partial<LoggerConfig>) {
    this.config = {
      ...this.config,
      ...partial,
    };
  }

  isEnabled(): boolean {
    return Boolean(this.config.enabled);
  }

  private formatPrefix(tag?: string): string {
    const base = this.config.prefix ? `[${this.config.prefix}]` : '';
    const withTag = tag ? `${base}[${tag}]` : base;
    return withTag || '';
  }

  log(message?: any, ...optionalParams: any[]) {
    if (!this.isEnabled()) return;
    console.log(this.formatPrefix(), message, ...optionalParams);
  }

  debug(message?: any, ...optionalParams: any[]) {
    if (!this.isEnabled()) return;
    console.debug(this.formatPrefix(), message, ...optionalParams);
  }

  info(message?: any, ...optionalParams: any[]) {
    if (!this.isEnabled()) return;
    console.info(this.formatPrefix(), message, ...optionalParams);
  }

  warn(message?: any, ...optionalParams: any[]) {
    if (!this.isEnabled()) return;
    console.warn(this.formatPrefix(), message, ...optionalParams);
  }

  error(message?: any, ...optionalParams: any[]) {
    if (!this.isEnabled()) return;
    console.error(this.formatPrefix(), message, ...optionalParams);
  }

  child(tag: string) {
    const parent = this;
    return {
      log: (message?: any, ...optionalParams: any[]) => {
        if (!parent.isEnabled()) return;
        const prefix = parent.formatPrefix(tag);
        console.log(prefix, message, ...optionalParams);
      },
      debug: (message?: any, ...optionalParams: any[]) => {
        if (!parent.isEnabled()) return;
        const prefix = parent.formatPrefix(tag);
        console.debug(prefix, message, ...optionalParams);
      },
      info: (message?: any, ...optionalParams: any[]) => {
        if (!parent.isEnabled()) return;
        const prefix = parent.formatPrefix(tag);
        console.info(prefix, message, ...optionalParams);
      },
      warn: (message?: any, ...optionalParams: any[]) => {
        if (!parent.isEnabled()) return;
        const prefix = parent.formatPrefix(tag);
        console.warn(prefix, message, ...optionalParams);
      },
      error: (message?: any, ...optionalParams: any[]) => {
        if (!parent.isEnabled()) return;
        const prefix = parent.formatPrefix(tag);
        console.error(prefix, message, ...optionalParams);
      },
    };
  }
}

export const logger = new Logger();
export type { LoggerConfig };
